module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step4_Image1.40b3d27d.webp";